import { GListBox, GTooltip } from 'components/basic-blocks'
import { GBadge } from 'components/basic-blocks/g-badge'
import { RiAlarmWarningLine } from 'react-icons/ri'
import { NavLink, useNavigate } from 'react-router-dom'
import { classNames } from 'utils'
import { TabItem, TabsProps } from './types'

export const GNewTabs = (props: TabsProps) => {
	const { current, tabs, actions, className , tabCols = 'grid-cols-3'} = props
	const navigate = useNavigate()

	const handleMultiSelectChange = (val: TabItem) => {
		navigate(val.disabled ? '#' : val.to())
	}

	return (
		<div className={classNames('pt-2', className || '')}>
			<div className="sm:hidden mb-4">
				<GListBox<TabItem>
					value={tabs.find((tab) => tab.key === current)}
					options={tabs}
					placeholder={'Select Link'}
					onChange={(val) => handleMultiSelectChange(val)}
					renderLabel={(tab) => (
						<div
							className={tab.disabled ? 'text-gray-300' : 'hover:text-t-dark'}
						>
							{tab.label}
						</div>
					)}
				/>
			</div>
			<div className="hidden sm:block border-b-t-traffic border-b">
				<div className="flex items-center space-x-6">
					<nav
						className={`flex-1 grid ${tabCols} items-center text-md -mb-px space-x-10`}
						aria-label="Tabs"
					>
						{tabs.map((tab: TabItem) => (
							<div key={tab.key}>
								{tab.show !== false && (
									<div
										className={classNames(
											tab.key === current
												? 'border-b-t-email-blue border-b-2'
												: '',
											tab.disabled ? 'text-gray-300' : '',
											'pb-3 -mb-px'
										)}
									>
										<div className="flex space-x-2 items-center justify-center">
											{tab.disabled ? (
												<div key={tab.key}>
													<div className="flex items-center space-x-1">
														<span className="text-lg">{tab.label}</span>
														{tab?.infoTooltip}
													</div>
												</div>
											) : (
												<NavLink key={tab.key} to={tab.to()}>
													<div className="flex items-center space-x-1">
														<span className="text-lg text-t-google-ad font-medium">
															{tab.label}
														</span>
														{tab?.infoTooltip}
													</div>
												</NavLink>
											)}
											<GTooltip content={tab.tooltip}>
												{tab.notification ? (
													<GBadge
														color={tab.notification?.color}
														text={
															tab.notification.value?.toString() || (
																<RiAlarmWarningLine />
															)
														}
													/>
												) : (
													<></>
												)}
											</GTooltip>
										</div>
									</div>
								)}
							</div>
						))}
						<div className="flex-1"></div>
					</nav>
				</div>
			</div>
		</div>
	)
}
